import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_vql.png",
      alt: "VQL Trading Quantitativo",
    },
    title: "Transforme seu Trading com VQL Trading Quantitativo",

    // String ou array de strings
    text: [
      "Na VQL Trading Quantitativo, acreditamos que o sucesso no mercado financeiro depende de controle e estratégia. Por isso, desenvolvemos soluções automatizadas de trading baseadas em modelos quantitativos e algoritmos avançados, garantindo que cada decisão seja embasada em dados concretos e que o risco seja calculado matematicamente.",
      "Com a VQL, você tem à disposição portfólios automatizados para day trade em futuros, preparados para entregar performance com segurança e consistência. ",
    ],
    testimonial: {
      text: ["O risco no mercado financeiro não é uma aposta, é uma variável controlada com matemática."],
      author: {
        name: "Icaro S., VQL Trading Quantitativo",
        // picture: 'https://ontick-img.s3.sa-east-1.amazonaws.com/raphael_qgdotrader_profile.png',
      },
    },
  },

  strategies: {
    title: "Estratégias VQL Trading Quantitativo",
    heading: "Automatização Inteligente no Mercado de Futuros",
    subtitle: [
      "O risco no mercado financeiro pode ser imprevisível, mas com a VQL, ele é controlado com precisão matemática. Comece agora mesmo!",
    ],
  },

  cta: {
    title: "Pronto para Automatizar seu Trading com Segurança?",
    subtitle: "Na VQL, o risco é controlado com matemática, não com suposições.",
  },

  about: {
    title: "Sobre a empresa",
    subtitle: "VQL Trading Quantitativo",
    col1: [
      "VQL Trading Quantitativo é uma empresa dedicada a entregar soluções de trading automatizadas e eficientes. Utilizando a mais avançada tecnologia em algoritmos e análises quantitativas, criamos portfólios personalizados para qualquer ativo com alta liquidez. Nossa missão é proporcionar aos nossos clientes resultados consistentes e sustentáveis, com estratégias otimizadas e baseadas em dados reais. ",
      "Combinamos inteligência artificial, estatística avançada e vasta experiência no mercado financeiro para oferecer uma experiência de trading que une precisão e controle de risco rigoroso. VQL Trading Quantitativo é sinônimo de inovação, performance e confiança no mercado financeiro, garantindo que cada decisão de trading seja fundamentada em análises robustas e automatizadas. ",
    ],
    col2: [
      "Ao escolher VQL Trading Quantitativo, você está escolhendo uma nova era de investimentos, onde a automatização de portfólios permite que traders e investidores aproveitem o máximo potencial do mercado, sem comprometer a segurança e a eficiência ou deixando que o emocional impacte nos resultados. ",
    ],
  },

  stats: {
    title: "Números que fazem da VQL uma referência em trading automatizado ",
    subtitle: "Resultados sólidos e tecnologia de ponta comprovam a eficácia dos nossos portfólios automatizados.",
    data: [
      {
        value: "+5",
        description: "Anos em atividade ",
      },
      {
        value: "+100",
        description: "Clientes Satisfeitos",
      },
      {
        value: "24/7",
        description: "de monitoramento e execução de trades, aproveitando oportunidades em tempo real. ",
      },
    ],
  },

  features: {
    type: 1,
    title: "Por quê utilizar os robôs da VQL Trading Quantitativo?",
    subtitle: "Veja quais as principais vantagens em escolher os nossos robôs.",
    data: [
      {
        icon: iconsSet.chip,
        title: "Automatização Completa",
        description:
          "Portfólios automatizados que operam de forma independente, seguindo estratégias avançadas de trading quantitativo.",
      },
      {
        icon: iconsSet.iconTabDetails,
        title: "Análises Baseadas em Dados",
        description:
          "Decisões de trading são tomadas com base em dados estatísticos robustos, eliminando o fator emocional.",
      },
      {
        icon: iconsSet.balance,
        title: "Gestão de Risco Otimizada",
        description:
          "Métodos rigorosos de cálculo de risco garantem proteção ao capital, minimizando perdas em cenários adversos e maximizando os lucros. ",
      },
      {
        icon: iconsSet.chat_round,
        title: "Suporte Personalizado",
        description:
          "Atendimento exclusivo e suporte contínuo para auxiliar traders e investidores em todas as etapas. ",
      },
      {
        icon: iconsSet.ranking,
        title: "Acesso a Estratégias Profissionais",
        description:
          "Beneficie-se das mesmas técnicas e estratégias utilizadas por grandes fundos e instituições financeiras. Utilizamos algoritmos de última geração e inteligência artificial para garantir precisão nas execuções. ",
      },
      {
        icon: iconsSet.yoga,
        title: "Economia de Tempo",
        description:
          "A automação permite que você foque em outras áreas enquanto o portfólio é gerenciado automaticamente, garantindo operações otimizadas.",
      },
      // ...defaultContent.features.data,
    ],
  },

  testimonials: [
    {
      text: "A VQL transformou a maneira como faço day trade. O controle de risco realmente funciona!",
      author: "João S.",
      job: "Trader Profissional ",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/eliseu-sandres-120x120.jpg",
    },
    {
      text: "Com a VQL, eu tenho confiança nas minhas operações automáticas e posso focar em outras áreas da minha vida.",
      author: "Maria F.",
      job: "Trader Independente",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/Victor-nardi-vilella-120x120.jpg",
    },
  ],

  plans: {
    title: "Planos",
    subtitle: "Conheça os nossos planos.",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
